<template>
  <View gap="md" direction="column">
    <PropertyPerformanceCard v-for="item in items" :key="item.propertyId" :item="item" />
  </View>
</template>

<script setup lang="ts">
import { View } from '@tallo/design-system';

import { UnitPerformanceScoreDto } from '../interfaces/property-performance.dto';
import PropertyPerformanceCard from './property-performance-card.vue';

defineProps<{ items: UnitPerformanceScoreDto[] }>();
</script>

<style scoped lang="scss"></style>
